import { render, staticRenderFns } from "./PathwayListAddNew.vue?vue&type=template&id=b41a5a88&"
import script from "./PathwayListAddNew.vue?vue&type=script&lang=js&"
export * from "./PathwayListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./PathwayListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports